import {styled} from '@esgi/ui/theme';
import {EntireSectionBlock} from '../../../../entire-section-block';

export const MarkingPeriodsBox = styled(EntireSectionBlock, {
	gap: '$1',
});
